import UpdateMenuAction from "../menu/update-menu-action";

class UserActionMoveObjects extends UpdateMenuAction {
    constructor(props) {
        super(props);
    }

    async execute() {
        GroupController.clearGroupDataForMove();
        await super.execute();
    }

    async stop() {
        await super.stop();
        mController.updateMenuItemAction('MoveFeatureEnabled', false);
    }
}

export default UserActionMoveObjects;
